<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="顧客ランク詳細"
          icon="point"
          class="customer-rank-header" />
      <BaseBackButton
          :is-show="showBackButton"
          :return-destination="'/customerRank'" />
      <BaseDetailMoveData
          :id="detailData.code"
          :list-index="listIndex"
          :mode="mode"
          :array-lists="sortedList"
          :path-parameter="['code']"
          title="ID"
          router-path="/customerRank/" />
    </el-row>
    <el-row>
      <el-col :span="8">
        <div class="edit-table-list">
          <div class="table-vertical">
            <div class="edit-button-wrap">
              <BaseButton v-show="showEditButton"
                  @click="edit()">
                編集
              </BaseButton>
              <BaseButton v-show="showCancelButton"
                  @click="cancel()">
                キャンセル
              </BaseButton>
              <BaseButton v-show="showSaveButton"
                  @click="save()">
                保存
              </BaseButton>
            </div>
            <BaseTableDetail
                :border="true"
                :table-set-list="detailDataSetList"
                :display-item="detailData"
                :editable="editable" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import * as define from '@/define'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

const EDITABLE = Object.freeze({
  [define.MODE.NORMAL]: Object.freeze({}),
  [define.MODE.EDIT]: Object.freeze({ name: true, rate: true }),
  [define.MODE.NEW]: Object.freeze({ name: true, rate: true })
})

const returnDestination = '/customerRank'

export default {
  name: 'CustomerRankDetail',
  mixins: [x, confirmDiscardOnLeave],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      detailDataSetList: [
        {
          label: 'ランクコード',
          properties: [
            { path: 'code', type: 'String' }
          ]
        },
        {
          label: 'ランク名称',
          properties: [
            { path: 'name', type: 'String', editableId: 'name', elementType: ELEMENT_TYPE.INPUT }
          ],
          horizontal: true
        },
        {
          label: 'ポイント倍率',
          properties: [
            { path: 'rate', type: 'Number', editableId: 'rate', elementType: ELEMENT_TYPE.INPUT_NUMBER, fractionDigits: 2 }
          ]
        }
      ],
      detailData: {},
      // sample データ
      getDataSample: [
        { code: 1, name: '一般', rate: 1 },
        { code: 2, name: '優待', rate: 1.3 },
        { code: 3, name: '上客', rate: 1.5 }
      ]
    }
  },
  computed: {
    defaultModel: () => { return { code: null, name: null, rate: 1.00 } },
    ...mapState({
      listIndex: (state) => state.CustomerRank.listIndex,
      tableSetList: (state) => state.CustomerRank.tableSetList,
      currentPage: (state) => state.CustomerRank.currentPage,
      size: (state) => state.CustomerRank.size,
      mode: (state) => state.CustomerRank.mode,
      returnList: (state) => state.CustomerRank.returnList
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    sortedList () {
      return this.$store.getters['sortedList']('CustomerRank', this.sortCondition('customerRankList'))
    },
    showBackButton () {
      return this.mode === define.MODE.NORMAL
    },
    showEditButton () {
      return this.mode === define.MODE.NORMAL
    },
    showSaveButton () {
      return this.mode !== define.MODE.NORMAL
    },
    showCancelButton () {
      return this.mode !== define.MODE.NORMAL
    },
    editable () {
      return EDITABLE[this.mode]
    }
  },
  created () {
    this.getDetailData()
    this.checkMode()
  },
  beforeRouteUpdate (to, from, next) {
    // 顧客ランク詳細間移動時の処理.
    next()
    this.getDetailData()
  },
  methods: {
    checkMode () {
      if (this.mode === define.MODE.EDIT) {
        this.$_ConfirmDiscardOnLeave_watchStart(this.detailData)
      }
    },
    edit () {
      this.setMode(define.MODE.EDIT)
      this.checkMode()
    },
    save () {
      this.$_ConfirmDiscardOnLeave_watchEnd()
      this.decideTransition()
    },
    cancel () {
      this.$_ConfirmDiscardOnLeave_watchEnd()
      this.decideTransition()
    },
    getDetailData () {
      this.$loadingService.show()
      const param = this.$route.params.id
      const g = () => {
        if (this.mode === define.MODE.NEW) {
          return this.defaultModel
        } else {
          // sampleData
          for (const item of this.getDataSample) {
            if (item.code === Number(param)) { return item }
          }
        }
      }
      this.detailData = g()
      this.$loadingService.close()
    },
    /**
     * 詳細画面への遷移方法を検知して、帰還する画面を決定します。
     */
    decideTransition: function () {
      if (this.returnList) {
        this.$store.dispatch({
          type: 'set',
          states: {
            'CustomerRank/returnList': false
          }
        })
        this.$router.push({ path: returnDestination })
      }
      this.setMode(define.MODE.NORMAL)
    },
    setMode (mode) {
      this.$store.commit({
        type: 'set',
        states: {
          'CustomerRank/mode': mode
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/point/CustomerRankDetailTop.vue